import { render, staticRenderFns } from "./BloodTransfusionTable.vue?vue&type=template&id=cb61eaca&"
import script from "./BloodTransfusionTable.vue?vue&type=script&lang=js&"
export * from "./BloodTransfusionTable.vue?vue&type=script&lang=js&"
import style0 from "./BloodTransfusionTable.vue?vue&type=style&index=0&id=cb61eaca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports